<template>
  <v-card tile>
    <v-card-title class="ma-0 pa-0">
      <v-toolbar dark>
        <v-toolbar-title>Retry</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn value="ignore" @click="ignore">
          <v-icon color="red" left>mdi-stop</v-icon>
          <span>Ignore</span>
        </v-btn>
        <v-btn icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card-title>
    <v-card-text class="ma-0 pa-0">
      <v-tabs vertical dark>
        <template v-for="(event, index) in events">
          <v-tab :key="index" class="d-flex justify-start" style="height: 70px">
            <v-icon left>
              mdi-account
            </v-icon>
            <div
              class="d-flex align-center text-caption text-capitalize font-weight-black"
            >
              <div>
                <v-row class="ma-0 pa-0">
                  {{ formatText(event.component) }}
                </v-row>
                <v-row class="ma-0 pa-0">
                  {{ formatText(event.type) }}
                </v-row>
                <v-row class="ma-0 pa-0">
                  {{ event.timestamp }}
                </v-row>
              </div>
              <v-chip
                :color="getStatusColor(event.status)"
                dark
                small
                class="ml-2"
              >
                <span style="width: 90px">{{ formatText(event.status) }}</span>
              </v-chip>
            </div>
          </v-tab>
          <v-tab-item :key="index">
            <EventRetryForm
              :order="event.order"
              :retry="event.retry"
              :retryTarget="event.retry_target"
              :retryType="event.retry_type"
              :retryOptions="event.retry_options"
              :correlationId="event.correlation_id"
              :additionalFields="event.additional_fields"
              :error="event.error"
              @retry="retry"
            />
          </v-tab-item>
        </template>
      </v-tabs>
    </v-card-text>
  </v-card>
</template>

<script>
import { pipeline } from ".";
import EventRetryForm from "./EventRetryForm";

export default {
  components: { EventRetryForm },
  props: {
    pipelineEvent: { type: Object },
  },
  computed: {
    events() {
      return this.pipelineEvent.events || [];
    },
  },
  methods: {
    getStatusColor: (status) => pipeline.getStatusColor(status),
    formatText(text) {
      return text ? text.replace(/_/g, " ") : "";
    },
    retry(order, retryOptions, retryTarget, retryType) {
      const eventId = this.pipelineEvent.id;
      this.$emit("retry", eventId, order, retryOptions, retryTarget, retryType);
    },
    ignore() {
      this.$emit("ignore");
    },
  },
};
</script>

<style></style>
